import { Link } from 'react-router-dom';
import { BhcLogo } from './BhcHeader';

/**
 * BhcFooter — shared footer for the Health Check funnel. `engagementLinks`
 * lets the business / trust pages swap their "The Engagement" column.
 * `disclaimer` swaps the legal blurb (trust adds "practice of law" line).
 */
export const BhcFooter = ({ engagementLinks = [], disclaimer }) => (
  <footer className="site-footer" data-testid="bhc-site-footer">
    <div className="wrap">
      <div className="site-footer__top">
        <div className="site-footer__col">
          <BhcLogo light style={{ marginBottom: '18px' }} />
          <p style={{ fontSize: '14px', lineHeight: 1.6, maxWidth: '34ch', color: 'rgba(255,255,255,.6)' }}>
            Kohari Gonzalez Oneyear &amp; Brown PLLC — licensed North Carolina CPAs. Luxury advisory, precision compliance.
          </p>
        </div>
        <div className="site-footer__col">
          <h4>The Engagement</h4>
          <ul>
            {engagementLinks.map((l) =>
              l.to ? (
                <li key={l.label}><Link data-testid="bhc-footer-link-5" to={l.to}>{l.label}</Link></li>
              ) : (
                <li key={l.label}><a data-testid="bhc-footer-a-1" href={l.href}>{l.label}</a></li>
              )
            )}
          </ul>
        </div>
        <div className="site-footer__col">
          <h4>Legal</h4>
          <ul>
            <li><Link data-testid="bhc-footer-link-4" to="/business-health-check/terms">Engagement Terms &amp; Conditions</Link></li>
            <li><Link data-testid="bhc-footer-link-3" to="/business-health-check/terms#scope">Scope of Services</Link></li>
            <li><Link data-testid="bhc-footer-link-2" to="/business-health-check/terms#privacy">Privacy Policy</Link></li>
            <li><Link data-testid="bhc-footer-link-1" to="/business-health-check/terms#refund">Refund &amp; Cancellation</Link></li>
          </ul>
        </div>
        <div className="site-footer__col">
          <h4>Offices</h4>
          <p className="site-footer__office">2740 East WT Harris Blvd, Suite 200<br />Charlotte, NC 28213 · (704) 599-3355</p>
          <p className="site-footer__office">6000 Fairview Road, Suite 1200<br />Charlotte, NC 28210 · By appointment</p>
          <p className="site-footer__office">121 Rolling Hill Road<br />Mooresville, NC 28117 · (704) 663-6213</p>
          <p className="site-footer__office">326 S. Main Street<br />Winston-Salem, NC 27101 · (336) 761-0366</p>
        </div>
      </div>
      <p className="site-footer__disclaimer">
        {disclaimer ||
          'This page describes a fixed-fee professional service offering. It is not tax, legal, or financial advice. Tax projections are estimates based on information provided and are not a guarantee of any result. The binding terms of any engagement are set out in the Engagement Terms & Conditions you accept before payment.'}
      </p>
      <div className="site-footer__bottom">
        <span>© 2026 Kohari Gonzalez Oneyear &amp; Brown PLLC. NC CPA firm registration on file.</span>
        <span style={{ marginLeft: 'auto' }}>Charlotte · Mooresville · Winston-Salem</span>
      </div>
    </div>
  </footer>
);
